/** eslint-disable */
import React, { Component } from 'react';

class Item extends Component {
	render() {
		const { imageId, id, onHover } = this.props;
		return (
			<a
				ref={ref => (this.ref = ref)}
				href="/"
				onClick={e => {
					e.preventDefault();
				}}
				onMouseEnter={() => onHover(id)}
				onMouseLeave={() => onHover(null)}
			>
				<use
					className="hover-photo"
					xlinkHref={`#photo-${imageId}`}
					mask={`url(#mask-${id})`}
				/>
				<use className="hover-path" xlinkHref={`#path-${id}`} />
			</a>
		);
	}
}

export default Item;
